import React from "react";
import { FaBoltLightning } from "react-icons/fa6";

const TrendingProjects = ({ projects }) => {
  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex items-center gap-3">
        <div
          className="flex w-fit items-center gap-2 sm:gap-2 xs:hidden sm:hidden md:flex lg:flex xl:flex"
          role="radiogroup"
        >
          <div
            className={`flex items-center whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-semibold transition-colors focus:outline-none border border-transparent text-neutral-0 bg-neutral-90 dark:bg-neutral-95`}
          >
            <FaBoltLightning className="mr-2 text-gold" /> Trending projects
          </div>
        </div>
        <div className="hidden h-6 w-px shrink-0 bg-neutral-20 dark:bg-neutral-90 xs:hidden sm:hidden md:flex lg:flex xl:flex"></div>
        <div className="relative flex w-full items-center gap-2 overflow-hidden">
          {projects?.map((p, index) => (
            <div className="shrink-0" style={{ opacity: 1, transform: "none" }}>
              <div
                className="rounded-full px-3 py-2 bg-neutral-90 dark:bg-neutral-95 text-xs font-semibold flex items-center cursor-pointer"
                tabindex="0"
                role="button"
              >
                <span
                  className={`${
                    index === 0
                      ? "text-gold"
                      : index === 1
                      ? "text-silver"
                      : index === 2
                      ? "text-bronze"
                      : "text-neutral-50"
                  }`}
                >
                  {index + 1}
                </span>
                <div
                  className="flex gap-0.5 text-neutral-0 dark:text-neutral-0 items-center"
                  tabindex="0"
                  role="button"
                >
                  <div
                    className="mx-2 relative flex w-fit shrink-0 items-center justify-center overflow-hidden rounded-full"
                    style={{ height: "24px", width: "24px" }}
                  >
                    <img
                      alt={`${p.name} logo`}
                      loading="lazy"
                      width="24"
                      height="24"
                      decoding="async"
                      data-nimg="1"
                      className=" "
                      srcset={p.logo}
                      style={{ color: "transparent" }}
                    />
                  </div>
                  {p.name}
                </div>
              </div>
            </div>
          ))}
          <div className="absolute right-0 h-full w-24 bg-gradient-to-r from-transparent to-neutral-0 dark:to-neutral-100"></div>
        </div>
      </div>
    </div>
  );
};

export default TrendingProjects;
